import classNames from "classnames";
import { useReducer, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Navbar } from "./NavBar";
import { Outlet, useLocation } from "react-router-dom";
import { defaultNavItems } from "./defaultNavItems";
import { SidebarItem } from "./SidebarItem";
import { useAuth } from "@/core/auth/contexts/AuthContext";
import { ScrollArea} from "@/components/ui/scroll-area";
import { useScreenWidth } from "@/lib/useScreenWidth";

export interface IState {
  expanded: boolean;
  open: boolean;
}

const reducer = (state: IState, action: string): IState => {
  switch (action) {
    case "TOGGLE":
      return { ...state, expanded: !state.expanded };
    case "TOGGLE_MOBILE":
      return { ...state, open: !state.open };
    default:
      return state;
  }
};

const Layout = () => {
  const [state, dispatch] = useReducer(reducer, {
    open: false,
    expanded: true,
  });
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(true);
  const { user } = useAuth();
  const isSm = useScreenWidth({ width: 640 });

  if (!user) {
    return "Loading";
  }

  return (
    <div
      className={classNames({
        "h-screen flex relative w-[100vw] overflow-hidden": true,
        "dark:bg-dBackground  dark:text-white text-black bg-background transition-colors duration-300 ease-in-out":
          true,
      })}
    >
      <Sidebar expanded={state.expanded} open={state.open} dispatch={dispatch}>
        {defaultNavItems
          .filter((item) => {
            return item.roles.includes(user.role);
          })
          .map((navItem) => {
            return (
              <SidebarItem
                dispatch={dispatch}
                key={navItem.label}
                icon={navItem.icon}
                text={navItem.label}
                href={navItem.href}
                active={navItem.href === location.pathname}
                alert={undefined}
              />
            );
          })}
      </Sidebar>
      <div
        className="w-full"
        style={{
          width:
            isSm && !state.expanded
              ? "calc(100vw - 72px)"
              : isSm
              ? "calc(100vw - 212px)"
              : "100%",
        }}
      >
        <div className="w-full">
          <Navbar
            appUser={user}
            open={state.open}
            expanded={state.expanded}
            dispatch={dispatch}
            routes={defaultNavItems}
            onMenuButtonClick={() => setShowSidebar((prev) => !prev)}
          />
        </div>
        <div style={{ height: "calc(100vh - 73px)" }} className="w-full p-3 overflow-auto">
            <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
